import axios from 'axios';
import util from '@/common/util';
// import { paramsSerializer } from '@/common/utils/url-params';

// Search interface optimization, using other separate interface in the middle
const REQUEST_URL_MAP = {
    default: '/api-site/search/realTimeListings',
    list: '/api-site/search/searchListListing',
    map: '/api-site/search/searchMapListing',
    nearby: '/api-site/search/nearby',
    breadCrumbs: '/api-site/search/breadCrumb', // change
    quickSearch: '/api-site/search/searchListingCount',
    neighborStats: '/api-site/search/neighborStats', // change
    nearbyNeighbor: '/api-site/search/nearbyNeighbor', // change
    neighborAvg: '/api-site/search/neighborAvg'
};

const getListingSearchSwitch = function(globalData) {
    const { listingSearchSwitch, searchCenter } = globalData;
    const turnOnListingSearchSwitch = listingSearchSwitch && searchCenter;
    return turnOnListingSearchSwitch;
};

const isMigrationAdvertLink = function(globalData) {
    const { migrationSite, isLandingPage } = globalData;
    let { query = {} } = this.pageLocation;
    let isUnCenterLink = !query.condition;
    let isAdvertisingLink = query['x_ads_source'] || query['x_ads_id'];
    return (
        !isLandingPage && migrationSite && isUnCenterLink && isAdvertisingLink
    );
};

// Reserve space for processing request parameters
const handleMdSearchCondition = function(params, globalData) {
    // The new search interface enables field optimization
    params = { ...params };
    if (getListingSearchSwitch.call(this, globalData)) {
        // Global custom list field extensions
        // View missing field keys in the search-request-return-fields-enum.json
        params.personalizingFields = globalData.searchPersonalizingFields || '';
    }
    if (isMigrationAdvertLink.call(this, globalData)) {
        delete params.condition;
    }
    return params2linkHash.call(this, params, globalData);
};

const getSearchRequestUrl = function(type = 'default', globalData) {
    if (getListingSearchSwitch.call(this, globalData)) {
        return REQUEST_URL_MAP[type] || REQUEST_URL_MAP['default'];
    } else {
        return REQUEST_URL_MAP['default'];
    }
};

const getPreNextUrl = function({ listingId, search }, globalData) {
    if (getListingSearchSwitch.call(this, globalData)) {
        return `/api-site/listing-detail/${listingId}/prevNext?${search}`;
    } else {
        return `/api-site/pre-next?listingId=${listingId}&${search}`;
    }
};

const mergeMlsOrg2HouseList = function(houseList = [], mlsOrgList = []) {
    return houseList.map(house => {
        if (!house.mlsOrg && mlsOrgList.length) {
            let mls = mlsOrgList.find(mlsOrg => mlsOrg.id === house.mlsOrgId);
            house.mlsOrg = Object.assign({}, mls || {}); // copy
            house.mlsOrg.cardTemplate = house.cardTemplate || '';
        }
        return house;
    });
};

const searchRealTimeListings = async function({
    params,
    type = 'default',
    globalData
}) {
    // console.log('searchRealTimeListings:', params);
    // console.trace();
    // console.groupEnd();
    params = await params2linkHash.call(this, params, globalData);
    return this.axiosIns.get(getSearchRequestUrl.call(this, type, globalData), {
        params
    });
};

const link2hashApi = {
    mapPath: {
        api: '/api-site/search-param/mapPath',
        responseKey: 'regionId'
    },
    quickSearch: {
        api: '/api-site/search-param/quickSearch',
        responseKey: 'optionId'
    }
};

const link2hashRequest = async function(type, value, isLocationMap = false) {
    let response;
    if (isLocationMap) {
        response = value.map(v => JSON.stringify(v));
    } else {
        response = JSON.stringify(value);
    }
    if (util.isBot) {
        return response; 
    }
    try {
        let { api, responseKey } = link2hashApi[type];
        let res = await this.axiosIns.post(api, value, { cacheKey: true });
        res.data[responseKey] && (response = res.data[responseKey]);
    } catch (error) {
        console.error(error);
    }
    return response;
};

const params2linkHash = async function(params, globalData) {
    params = util.cloneData(params);
    const { searchCenter } = globalData;
    let { mapPath, condition = '' } = params;

    // searchCenter=true
    if (
        searchCenter &&
        typeof condition === 'string' &&
        condition.indexOf('mapPath') > -1
    ) {
        condition = util.jsonParse(condition, {});

        let temp = '';
        let locationMapPath = condition.location?.mapPath;
        if (locationMapPath) {
            if (typeof locationMapPath == 'string') {
                temp = util.jsonParse(locationMapPath);
            } else {
                temp = locationMapPath.map(point => {
                    return typeof point === 'string'
                        ? util.jsonParse(point)
                        : point;
                });
            }
            if (temp) {
                condition.location.mapPath = await link2hashRequest.call(
                    this,
                    'mapPath',
                    temp,
                    true
                );
            }
            
            params.condition = JSON.stringify(condition);
        }
    }
    // searchCenter=false
    mapPath = util.jsonParse(mapPath);
    if (mapPath) {
        params.mapPath = await link2hashRequest.call(
            this,
            'mapPath',
            mapPath
        );
    }
    return params;
};
const getNbrLinkForFeatureArea = function({
    areaType,
    area,
    aggType,
    aggSize,
    searchCenter,
    siteId,
    details
}) {
    let url = (url = `/api-nonsearchcenter/search/featureArea/geoAggByCity`);
    let params = Array.prototype.shift.call(arguments);
    if (searchCenter) {
        url = `/api-searchcenter/featureArea/${siteId}/geoAggByCity`;
        delete params.siteId;
    }
    delete params.searchCenter;
    return this.axiosIns.get(url, { params });
};
const getFeatureAreaStatistics = function({
    areaType,
    area,
    statsTypes,
    siteId,
    searchCenter
}) {
    let url = `/api-nonsearchcenter/search/featureArea/statistics`;
    let params = Array.prototype.shift.call(arguments);
    if (searchCenter) {
        url = `/api-searchcenter/featureArea/${siteId}/statistics`;
        delete params.siteId;
    }
    return axios.get(url, { params });
};
export {
    isMigrationAdvertLink,
    handleMdSearchCondition,
    getSearchRequestUrl,
    searchRealTimeListings,
    mergeMlsOrg2HouseList,
    params2linkHash,
    getPreNextUrl,
    getNbrLinkForFeatureArea,
    getFeatureAreaStatistics
};
